import { render, staticRenderFns } from "./ClinicalData.vue?vue&type=template&id=7a88039e"
import script from "./ClinicalData.vue?vue&type=script&lang=js"
export * from "./ClinicalData.vue?vue&type=script&lang=js"
import style0 from "./ClinicalData.vue?vue&type=style&index=0&id=7a88039e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports